/* eslint-disable react/jsx-props-no-spreading */
// import { FormattedMessage } from 'react-intl';
// import { PropTypes as MicromagPropTypes } from '@micromag/core';
import { FieldWithForm as FieldWithFormField } from '@micromag/fields';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

const propTypes = {
    value: PropTypes.shape({
        weight: PropTypes.string,
        style: PropTypes.shape({}),
        media: PropTypes.shape({}),
    }),
};

const defaultProps = {
    value: null,
};

const FontVariantField = ({ value, ...props }) => {
    const { media = null, weight = null, style = null } = value || {};
    const { name: mediaName = null } = media || {};

    const valueName = useMemo(
        () => [weight, style].filter((it) => it !== null).join(' '),
        [weight, style],
    );

    return (
        <FieldWithFormField
            value={value}
            {...props}
            label={
                mediaName !== null ? (
                    <>
                        <span className="mx-3">{mediaName}</span>
                        <span>{valueName}</span>
                    </>
                ) : (
                    valueName
                )
            }
            thumbnail={
                value !== null ? (
                    <strong
                        className={classNames(['d-inline-block'])}
                        style={{ fontWeight: value.weight || null, fontStyle: value.style || null }}
                    >
                        Aa
                    </strong>
                ) : null
            }
        />
    );
};

FontVariantField.propTypes = propTypes;
FontVariantField.defaultProps = defaultProps;
FontVariantField.withForm = true;

export default FontVariantField;
